/**
 * End and start parameters must be momentJS instances
 **/
export default function (start, end) {

    let result = '';
    const duration = end.diff(start, 'minutes');
    let minutes = 0;

    if (duration <= 0) {
        return 0;
    }

    let hours = Math.floor(duration / 60);

    if (hours >= 1 && duration >= 60) {
        minutes = duration % 60;
    } else {
        minutes = duration
    }

    if (minutes) {
        if (minutes < 10) {
            minutes = '0' + minutes;
        }
        result = hours + ":" + minutes;
    } else {
        result = hours;
    }

    return result;
}